import React from 'react';
import '../styles/CTA.css';


function CTA() {
  return (
    <div className="cta-outer-wrapper">
      <div className="cta-container">
        <div className="cta-images">
          <img src="/images/cta.jpg" alt="CTA 1" className="cta-img" />
          <img src="/images/experience.jpg" alt="CTA 2" className="cta-img second-img" />
          <img src="/images/project.webp" alt="CTA 1" className="cta-img" />
        </div>
        <div className="cta-text">
          <h2>Take part in the internship training!</h2>
          <p>Join our internship program to gain hands-on experience in real-world projects.</p>
          <a href="/register" className="cta-button">Register Now</a>
        </div>
      </div>
    </div>
  );
}

export default CTA;
